module.exports = __webpack_public_path__ + "img/Flag_of_the_Netherlands.e53fc83f.svg";